<template>
	<div>
		<Loading v-if="loading" text="Lade Ausschlüsse..."/>
		<template v-else>
			<JonInfo v-if="exclusions.length === 0">
				<template #message>
					Es sind noch keine Einträge vorhanden.
				</template>
			</JonInfo>
			<div v-else class="items-list">
				<ListItem
					v-for="exclusion in exclusions"
					:key="exclusion.id"
					:exclusion="exclusion"
					@remove="loadExclusions"
				/>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="loadExclusions"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Pagination from "@/vue/common/Pagination";
import ListItem from "./ListItem";
import GetList from "@/api/application/exclusion/GetList";
import JonInfo from "@/vue/common/JonInfo";

export default {

	components: {
		Pagination,
		ListItem,
		Loading,
		JonInfo
	},

	mounted ()
	{
		this.loadExclusions();
	},

	data ()
	{
		return {
			loading: true,
			exclusions: null,
			meta: null,
			page: 1,
			itemsPerPage: 10,
		};
	},

	methods: {
		async loadExclusions ()
		{
			this.loading = true;

			const response = await new GetList()
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage)
				.call();

			this.exclusions = response.data;
			this.meta = response.meta;

			this.loading = false;
		}
	}
}
</script>
